var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiExclamationOctagonSolid24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-exclamation-octagon-solid",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.293A1 1 0 0 1 8.207 2h7.586a1 1 0 0 1 .707.293L21.707 7.5a1 1 0 0 1 .293.707v7.586a1 1 0 0 1-.293.707L16.5 21.707a1 1 0 0 1-.707.293H8.207a1 1 0 0 1-.707-.293L2.293 16.5A1 1 0 0 1 2 15.793V8.207a1 1 0 0 1 .293-.707L7.5 2.293zM11.5 7v7h1V7h-1zm-.25 10h1.5v-1.5h-1.5V17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiExclamationOctagonSolid24Px);
export default __webpack_public_path__ + "static/media/mi-exclamation-octagon-solid-24px.af9825dbf9e952f84e037190b25fdddc.svg";
export { ForwardRef as ReactComponent };